import { useState } from 'react';
import { useDeconnexion, useFile } from '../horsligne/contexte-file';

/**
 * Le téléphone garde des saisies d'un autre compte (docs/UI.md § Écran 3, mode
 * hors ligne). Seul ce compte peut les envoyer : l'utilisateur connecté choisit
 * de les effacer ou de se déconnecter. La file n'envoie rien tant qu'il n'a pas
 * choisi.
 */
export function SaisiesAutreCompte() {
  const { instantane, effacerAutresComptes } = useFile();
  const { demander } = useDeconnexion();
  const [occupe, setOccupe] = useState(false);
  const n = instantane.autresComptes;
  if (n === 0) return null;
  const plusieurs = n > 1;

  async function executer(action: () => Promise<void>): Promise<void> {
    setOccupe(true);
    try {
      await action();
    } finally {
      setOccupe(false);
    }
  }

  return (
    <div className="dialogue-fond">
      <dialog open className="dialogue" aria-modal="true" aria-labelledby="titre-autre-compte">
        <h2 id="titre-autre-compte">Saisies d’un autre compte</h2>
        <p>
          Ce téléphone garde {n} {plusieurs ? 'saisies faites' : 'saisie faite'} avec un autre compte, pas encore{' '}
          {plusieurs ? 'envoyées' : 'envoyée'}. Seul ce compte peut {plusieurs ? 'les envoyer' : 'l’envoyer'}, en se
          reconnectant sur ce téléphone. Si vous continuez, {plusieurs ? 'elles seront effacées' : 'elle sera effacée'}{' '}
          définitivement.
        </p>
        <div className="actions">
          <button
            type="button"
            className="bouton-second"
            disabled={occupe}
            onClick={() => void executer(demander)}
          >
            {plusieurs ? 'Me déconnecter pour que l’autre compte les envoie' : 'Me déconnecter pour que l’autre compte l’envoie'}
          </button>
          <button
            type="button"
            className="bouton bouton-danger"
            disabled={occupe}
            onClick={() => void executer(effacerAutresComptes)}
          >
            Effacer ces saisies et continuer
          </button>
        </div>
      </dialog>
    </div>
  );
}
